import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  public isCollapsed = true;

  user: any;
  conf: any
  url: string = environment.configUrl;
  constructor(private route: Router, private http: HttpClient) {
    this.user = JSON.parse(UturuncoUtils.getSession("user"))
  }
  getuser() {
    this.user = JSON.parse(UturuncoUtils.getSession("user"))
    return this.user;

  }
  ngOnInit() {
    this.http.get(this.url).subscribe(res => {
      this.conf = res;
    });
  }

  cerrar() {
    UturuncoUtils.clearSession();
    this.route.navigate([""]);
  }

}
